import { useObserver, useSubtree } from "subtree.js/react";
import { LoadFailed, Loading } from "../../components/LoadState";
import { UnrecognisedScan } from "../../components/UnrecognisedScan";
import { useIsMobile } from "../../components/use-is-mobile";
import { ScanEditor } from "../../sections/scan-editor/scan-editor";
import { ScanEditorState } from "../../sections/scan-editor/scan-editor-model";
import { EditScanActions, EditScanState } from "./edit-scan-model";

export function EditScanPage() {
  const state = useSubtree(EditScanState);
  const editor = useSubtree(ScanEditorState);
  const actions = useSubtree(EditScanActions);
  const observer = useObserver();
  const isMobile = useIsMobile();

  const status = observer.watch(state.status);
  const scan = observer.watch(editor.scan);
  const noMatch = observer.watch(state.noMatch);
  const loading = status === "loading";
  const pending = scan?.review === "PENDING";

  if (noMatch)
    return (
      <div className="mx-auto max-w-3xl px-4 py-8">
        <UnrecognisedScan scan={noMatch} uploadLink />
      </div>
    );

  return (
    <div className="mx-auto max-w-7xl px-4 py-8 sm:px-6 lg:px-8">
      <div className="panel p-6">
        {loading && <Loading label="Loading the scan…" />}
        {status === "notFound" && <p className="py-4 text-sm text-muted">This scan no longer exists.</p>}
        {status === "error" && <LoadFailed title="Couldn't load this scan." onRetry={actions.retry} />}
        {!loading && status === "ready" && scan && (
          <>
            {!pending && (
              // Confirming is a once-only step, so a scan that has been through
              // it says so rather than offering a button the backend refuses.
              <p className="note note-neutral mb-4 text-muted">
                This scan was already {scan.review === "REJECTED" ? "rejected" : "confirmed"}. Prices and stock for its
                card are edited from the inventory.
              </p>
            )}
            <ScanEditor
              isMobile={isMobile}
              // Approving a customer's scan answers their quote; approving your
              // own adds the card and its stock.
              confirmLabel={state.mode === "approve" ? "Approve" : "Confirm"}
              cancelLabel="Cancel"
              onCancel={actions.cancel}
              showReject={pending}
            />
          </>
        )}
      </div>
    </div>
  );
}
